import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const isDesignTokenFontSize = (value: string) =>
  /^(label|body|heading)-(xs|sm|md|lg|xl|2xl)-(r|m|sb|b)$/.test(value);

const isGlobalSpacing = (value: string) => /^global-spacing-\d+$/.test(value);
const isGlobalRadius = (value: string) => /^global-radius-\d+$/.test(value);

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [isDesignTokenFontSize] }],
      // border-radius: rounded-global-radius-* 를 tailwind-merge 가 인식하게 등록.
      // 없으면 base 의 global-radius 토큰 클래스와 compound 의 6px arbitrary 값이
      // 안 합쳐져 둘 다 남고, CSS 순서로 8px 가 이겨 각진 6px 태그가 둥글게 보였다.
      rounded: [{ rounded: [isGlobalRadius] }],
      'rounded-s': [{ 'rounded-s': [isGlobalRadius] }],
      'rounded-e': [{ 'rounded-e': [isGlobalRadius] }],
      'rounded-t': [{ 'rounded-t': [isGlobalRadius] }],
      'rounded-r': [{ 'rounded-r': [isGlobalRadius] }],
      'rounded-b': [{ 'rounded-b': [isGlobalRadius] }],
      'rounded-l': [{ 'rounded-l': [isGlobalRadius] }],
      'rounded-tl': [{ 'rounded-tl': [isGlobalRadius] }],
      'rounded-tr': [{ 'rounded-tr': [isGlobalRadius] }],
      'rounded-br': [{ 'rounded-br': [isGlobalRadius] }],
      'rounded-bl': [{ 'rounded-bl': [isGlobalRadius] }],
      p: [{ p: [isGlobalSpacing] }],
      px: [{ px: [isGlobalSpacing] }],
      py: [{ py: [isGlobalSpacing] }],
      pt: [{ pt: [isGlobalSpacing] }],
      pr: [{ pr: [isGlobalSpacing] }],
      pb: [{ pb: [isGlobalSpacing] }],
      pl: [{ pl: [isGlobalSpacing] }],
      // 논리 인라인 속성(RTL 대응) — 미등록 시 ps-16/ps-8 이 둘 다 남아
      // 오버라이드가 안 먹는다(캐러셀 간격 회귀의 원인).
      ps: [{ ps: [isGlobalSpacing] }],
      pe: [{ pe: [isGlobalSpacing] }],
      m: [{ m: [isGlobalSpacing] }],
      mx: [{ mx: [isGlobalSpacing] }],
      my: [{ my: [isGlobalSpacing] }],
      mt: [{ mt: [isGlobalSpacing] }],
      mr: [{ mr: [isGlobalSpacing] }],
      mb: [{ mb: [isGlobalSpacing] }],
      ml: [{ ml: [isGlobalSpacing] }],
      ms: [{ ms: [isGlobalSpacing] }],
      me: [{ me: [isGlobalSpacing] }],
      gap: [{ gap: [isGlobalSpacing] }],
      'gap-x': [{ 'gap-x': [isGlobalSpacing] }],
      'gap-y': [{ 'gap-y': [isGlobalSpacing] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
